import {
  ChecklistItemsResultEntity,
  ChecklistItemsTabStatus,
} from "../../entities/ChecklistEntity";
import { ChecklistRepository } from "../../repositories/ChecklistRepository";

/**
 * Get Checklist Items Use Case
 * Fetches paginated checklist items by accounting area
 */
export class GetChecklistItemsUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(
    month: string,
    accountingArea: string,
    offset: number = 0,
    limit: number = 20,
    status?: ChecklistItemsTabStatus | null
  ): Promise<ChecklistItemsResultEntity> {
    return await this.repository.getItemsByArea(
      month,
      accountingArea,
      offset,
      limit,
      status
    );
  }
}

